import {
  autocompleteAtCursor,
  canAutocompleteAtCursor,
  getTextBeforeCursor,
} from '../../helpers/textUnderCursor';
import { BaseService, Service } from '../base/service';
import { TextUnderCursorService } from './textUnderCursorService';

export interface AutocompleteService extends Service {
  readonly textBeforeCursor: string;

  getBoundingClientRect(incompleteText: string): ClientRect | undefined;

  autocomplete(incompleteText: string, completeText: string): void;
}

export function createAutocompleteService(
  textUnderCursorService: TextUnderCursorService,
): AutocompleteService {
  return new BaseAutocompleteService(textUnderCursorService);
}

export class BaseAutocompleteService extends BaseService implements AutocompleteService {
  constructor(textUnderCursorService: TextUnderCursorService) {
    super(textUnderCursorService);

    this.textUnderCursorService = textUnderCursorService;
  }

  private readonly textUnderCursorService: TextUnderCursorService;

  get textBeforeCursor() {
    const { isActive, textUnderCursor } = this.textUnderCursorService;
    if (!isActive || !canAutocompleteAtCursor(textUnderCursor)) {
      return '';
    }

    return getTextBeforeCursor(textUnderCursor);
  }

  getBoundingClientRect(incompleteText: string): ClientRect | undefined {
    const { textUnderCursor } = this.textUnderCursorService;
    if (!canAutocompleteAtCursor(textUnderCursor, incompleteText)) {
      return undefined;
    }

    const { focusOffset } = textUnderCursor;
    return this.textUnderCursorService.getBoundingClientRect({
      startOffset: focusOffset - incompleteText.length,
      endOffset: focusOffset,
    });
  }

  autocomplete(incompleteText: string, completeText: string) {
    const { textUnderCursor } = this.textUnderCursorService;
    const newTextUnderCursor = autocompleteAtCursor(textUnderCursor, incompleteText, completeText);
    if (textUnderCursor === newTextUnderCursor) {
      return;
    }

    this.textUnderCursorService.setTextUnderCursor(newTextUnderCursor);
  }
}
